<form #policyRuleForm="ngForm" (ngSubmit)="policyRuleForm.valid && close()">
    <div class="mon-dialog-body-with-footer auto-scroll policy-form-dialogs-rule px-3">
        <div class="row">
            <div class="col-48">
                <div class="form-group mt-4"
                     [ngClass]="{'has-error': policyRuleForm.form.get('name')?.invalid && (policyRuleForm.form.get('name')?.dirty || policyRuleForm?.submitted)}">
                    <label for="rule_name" class="col-form-label text-bold"><span translate>Rule name</span>*</label>
                    <input id="rule_name"
                           name="name"
                           type="text"
                           [(ngModel)]="cRule.name"
                           required
                           class="form-control"/>
                    <form-field-errors [input]="policyRuleForm.name" offset="0"></form-field-errors>
                </div>
            </div>

            <div class="col-48">
                <div class="form-group" [ngClass]="{'has-error': policyRuleForm.form.get('operator')?.invalid && (policyRuleForm.form.get('operator')?.dirty || policyRuleForm?.submitted)}">
                    <label class="col-form-label text-bold"><span translate>Want to search for</span>*</label>
                    <div>
                        <form-field-select name="operator" required [(ngModel)]="cRule.operator" [options]="typeOptions" nameAttr="translation" returnValue="type"></form-field-select>
                        <form-field-errors [input]="policyRuleForm.form.get('operator')" offset="0"></form-field-errors>
                    </div>
                </div>
            </div>

            <div class="col-48">
                <div class="form-group" [ngClass]="{'has-error': policyRuleForm.form.get('query')?.invalid && (policyRuleForm.form.get('query')?.dirty || policyRuleForm?.submitted)}">
                    <label class="col-form-label text-bold"><span translate>Readability score</span>*</label>
                    <div>
                        <form-field-select name="query" required [(ngModel)]="cRule.query" [options]="queryOptions" nameAttr="translation" returnValue="value"></form-field-select>
                        <form-field-errors [input]="policyRuleForm.form.get('query')" offset="0"></form-field-errors>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mon-dialog-footer">
        <div class="row">
            <div class="col-48 text-right">
                <button type="submit"
                        [disabled]="policyRuleForm.invalid"
                        class="btn btn-border-radius btn-secondary"
                        translate>
                    Save
                </button>
            </div>
        </div>
    </div>
</form>
